/**
 * Parties — soft teal / indigo accent (light theme)
 */
export const PARTIES_THEME = {
  title: 'Parties',
  subtitle: 'Customers, suppliers, and business contacts',
  historyTitle: 'Directory',
  searchPlaceholder: 'Search name, phone, email, GSTIN…',

  pageBg: 'bg-slate-50',
  header: 'from-teal-50/90 via-white to-indigo-50/70',
  headerAccentLine: 'h-px bg-teal-100/80',
  cardBorder: 'border-slate-200/60',
  cardShadow: 'shadow-sm',
  iconTile: 'bg-gradient-to-br from-teal-400 to-cyan-300 shadow-sm',
  iconAccent: 'text-teal-600',
  modalRing: 'border-slate-200/70',

  subNavActive: 'bg-white text-teal-800 shadow-sm ring-1 ring-teal-100',
  subNavIdle: 'text-slate-600 hover:text-slate-900 hover:bg-white/80',
  subNavIdleBg: 'from-teal-50/90 via-white to-indigo-50/70 border-teal-100',

  statPill: 'rounded-lg bg-white/90 border border-teal-100/70 px-2.5 py-1 text-[11px] text-slate-600',
  statPillStrong: 'font-bold text-teal-800 tabular-nums',

  tabNavBg: 'bg-gradient-to-r from-teal-50/90 via-white to-indigo-50/70 border border-teal-100/70',
  tabActive: 'bg-white text-teal-800 shadow-sm ring-1 ring-teal-100',
  tabIdle: 'text-slate-600 hover:text-slate-900 hover:bg-white/80',

  btn: 'from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600',
  /** Primary CTA — Add party (stronger than generic btn) */
  btnAddParty:
    'from-teal-600 to-cyan-500 hover:from-teal-700 hover:to-cyan-600 shadow-md ring-2 ring-teal-200/90 hover:ring-teal-300/90 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-offset-1',
  btnRing: 'focus:ring-teal-400',
  btnSecondary:
    'text-slate-700 border-slate-200 hover:bg-slate-50 hover:border-slate-300',
  ghostLink: 'text-[11px] text-slate-600 hover:text-slate-900 font-medium',

  fieldFocus: 'focus:border-teal-400 focus:outline-none focus:ring-2 focus:ring-teal-400/15',
  filterFocus: 'focus:border-teal-400 focus:ring-teal-400/15',
  filterPillActive: 'bg-teal-500 text-white shadow-sm',
  filterPillIdle: 'bg-white text-slate-700 ring-1 ring-slate-200 hover:ring-teal-100',
  filterBarBg: 'bg-teal-50/25',
  borderSoft: 'border-slate-200/70',
  mutedText: 'text-slate-500',
  hoverRow: 'hover:bg-teal-50/25',
  tableHead: 'bg-teal-50/60 sticky top-0 z-10',
  tableHeadText: 'text-teal-800/75',
  tableDivide: 'divide-slate-200',
  tbodyDivide: 'divide-slate-100',
  checkboxBorder: 'border-slate-300',
  formPanelBg: 'bg-white',
  divider: 'divide-slate-200',
  checkbox: 'text-teal-500 focus:ring-teal-400',
  editIcon: 'text-teal-700 bg-teal-50/80 hover:bg-teal-100/80',
  emptyIcon: 'text-teal-200',
  emptyBg: 'bg-teal-50/30',
  emptyBorder: 'border-teal-100/60',
  emptyTitle: 'text-slate-800',
  subtitleOnHeader: 'text-slate-500',
  sectionWrap: 'rounded-xl border border-teal-100/50 bg-teal-50/15 p-3',
  sectionHead: 'text-xs font-semibold uppercase tracking-wide text-teal-800/75',
  openingBalanceBox: 'border-slate-200/70 bg-slate-50/80',
  openingBalanceSummary: 'text-slate-700',
  messageOk: 'bg-emerald-50 text-emerald-900 border-emerald-200',
  messageErr: 'bg-red-50 text-red-800 border-red-200',

  panelHeader:
    'p-4 border-b border-teal-100/70 bg-gradient-to-r from-teal-50/90 via-white to-indigo-50/60',
  contentCard: 'bg-white rounded-xl shadow-sm overflow-hidden border border-slate-200/50',
  modalOverlay:
    'fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-slate-900/50 backdrop-blur-sm p-0 sm:p-4',
  modalPanel:
    'relative z-[101] flex w-full sm:w-[min(96vw,1200px)] max-h-[92dvh] sm:max-h-[94dvh] flex-col rounded-t-2xl sm:rounded-2xl bg-white shadow-xl border border-slate-200/70 overflow-hidden',

  /** Summary stat cards on main page */
  statCardTotal: 'bg-white rounded-xl border border-slate-200/70 p-4 shadow-sm',
  statCardCustomers: 'bg-gradient-to-br from-emerald-50/80 to-teal-50/60 rounded-xl border border-emerald-100/60 p-4 shadow-sm',
  statCardSuppliers: 'bg-gradient-to-br from-indigo-50/80 to-violet-50/50 rounded-xl border border-indigo-100/60 p-4 shadow-sm',
  statCardOther: 'bg-gradient-to-br from-amber-50/80 to-orange-50/40 rounded-xl border border-amber-100/60 p-4 shadow-sm',
};

export const btnPrimarySm =
  'inline-flex items-center justify-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-white bg-teal-500 rounded-lg hover:bg-teal-600 transition-colors shadow-sm';
export const btnSecondarySm =
  'inline-flex items-center justify-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-teal-800 bg-teal-50/80 rounded-lg hover:bg-teal-100/80 transition-colors';
export const btnDangerSm =
  'inline-flex items-center justify-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition-colors';

export const fieldBase =
  'w-full rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-sm text-gray-900';
export const formLabelCls = 'mb-0.5 block text-xs font-medium text-slate-600';
export const formFieldCls = fieldBase;

export function isSupplierPartyType(type) {
  return type === 'Seller' || type === 'Supplier' || type === 'Both';
}

export function partyMatchesTypeFilter(party, filterType) {
  if (filterType === 'All') return true;
  if (filterType === 'Buyer') return party.partyType === 'Buyer';
  if (filterType === 'Supplier') return isSupplierPartyType(party.partyType);
  return party.partyType === filterType;
}

export function partyTypeBadgeClass(type) {
  switch (type) {
    case 'Buyer':
      return 'bg-emerald-50/80 text-emerald-800 ring-emerald-100/80';
    case 'Seller':
    case 'Supplier':
      return 'bg-indigo-50/80 text-indigo-800 ring-indigo-100/80';
    case 'Both':
      return 'bg-amber-50/80 text-amber-800 ring-amber-100/80';
    default:
      return 'bg-slate-50 text-slate-600 ring-slate-100';
  }
}

export function partyTypeLabel(type) {
  if (type === 'Seller' || type === 'Supplier') return 'Supplier';
  if (type === 'Both') return 'Both';
  return type || 'Buyer';
}
